import { userCreateDetailsSteps, userCreateReportSteps, userCreateRoleSteps, usersCreateSteps } from './Create.tsx';
import { userEditDetailsSteps, userEditReportSteps, userEditRoleSteps, userEditSteps } from './Edit.tsx';
import { userSteps } from './Users.tsx';

/**
 * 
 * @param {*} path path of the page
 * @param {*} query 
 * @param {*} activeTab acttive tab if availabe 
 * @returns 
 */
export const getUserJoyrideSteps = (path, query, activeTab) => {
  console.log("active tab",activeTab)
  if (path === "/users") {
    return userSteps;
  }

  if (path === "/users/edit") {
    const id = query.get("id");
    const isCreate = id === "0";
    const isEdit = id && id !== "0";

    const baseSteps = isCreate ? usersCreateSteps : isEdit ? userEditSteps : [];

    const tabStepsMap = {
      details: {
        create: userCreateDetailsSteps,
        edit: userEditDetailsSteps,
      },
      roles: {
        create: userCreateRoleSteps,
        edit: userEditRoleSteps,
      },
      reports: {
        create: userCreateReportSteps,
        edit: userEditReportSteps,
      },
    };

    const tabSteps =
      tabStepsMap?.[activeTab]?.[isCreate ? "create" : "edit"] || [];
    return [...baseSteps, ...tabSteps];
  }

  return [];
};